import React from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

interface PreviousLogUnitMiniTableProps {
  title: string;
  data: any[];
}

const PreviousLogUnitMiniTable: React.FC<PreviousLogUnitMiniTableProps> = (props) => {
  let { data, title } = props;

  const noDateData = data?.filter((item) => item?.[0]?.display_name !== 'Submit Date');

  return (
    <Table size="small">
      <TableHead>
        <TableRow style={{ background: '#A21C37' }}>
          <TableCell style={{ width: '250px', color: '#fff', fontWeight: 700 }}>{title}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {noDateData?.map((item, index) => (
          <TableRow key={index}>
            <TableCell>{item?.[0].display_name}</TableCell>
            <TableCell>{item?.[0].value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PreviousLogUnitMiniTable;
